import { render, staticRenderFns } from "./EuropeanPoliciesAndStrategies.vue?vue&type=template&id=4075e871&scoped=true"
import script from "./EuropeanPoliciesAndStrategies.vue?vue&type=script&lang=js"
export * from "./EuropeanPoliciesAndStrategies.vue?vue&type=script&lang=js"
import style0 from "./EuropeanPoliciesAndStrategies.vue?vue&type=style&index=0&id=4075e871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075e871",
  null
  
)

export default component.exports